import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import I18n from 'lib/i18n/i18n';
import {isMobile} from 'helpers/ApplicationHelper';
import PopupHelp from 'components/popups/popupHelp';
import {updateSubmissionProgressState} from 'actions/submissionProgress';

class ShippingLabel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            item: props.item,
            pickupLocations: []
        };

        this._onHelp = this._onHelp.bind(this);
    }
 // upgrade change
    componentDidMount() {
        this.props.updateSubmissionProgressState('shipping label');
        let locations = this.state.item && this.state.item.shipment && this.state.item.shipment.locations;
        if (!locations) {
            return;
        }
        let pickupLocations = [];
        if (!!locations[0]) {
            pickupLocations[0] = (
                <figure key="pickup-location1">
                    <h5>{locations[0].name}</h5>
                    <p>
                        <a href={`https://www.google.co.il/maps/place/${locations[0].address.StreetLines},${locations[0].address.City},${locations[0].address.StateOrProvinceCode}`} target="_blank">{locations[0].address.StreetLines}, {locations[0].address.City}, {locations[0].address.StateOrProvinceCode} {locations[0].address.PostalCode}</a>
                    </p>
                </figure>
            );
        }
        if (!!locations[1]) {
            pickupLocations[1] = (
                <figure key="pickup-location2">
                    <h5>{locations[1].name}</h5>
                    <p>
                        <a href={`https://www.google.co.il/maps/place/${locations[1].address.StreetLines},${locations[1].address.City},${locations[1].address.StateOrProvinceCode}`} target="_blank">{locations[1].address.StreetLines}, {locations[1].address.City}, {locations[1].address.StateOrProvinceCode} {locations[1].address.PostalCode}</a>
                    </p>
                </figure>
            );
        }
        this.setState({pickupLocations});
    }

    componentWillUnmount() {
        this.props.updateSubmissionProgressState();
    }

    _onHelp(event) {
        event.preventDefault();
        PopupHelp.initPopup({single: true, modal: true});
    }

    render() {
        let phoneNumber = I18n.getString('common::phoneNumberString');
        let callNowText = I18n.getString('itemPage::shippingLabel::callUs::desktop', {phoneNumber: phoneNumber});
        return (
            <div id="item-shipping-label">
                <div className="item-shipping-label-container">
                    <h1>{I18n.getString('itemPage::shippingLabel::title')}</h1>
                    <div className="top-text">
                        <span>{I18n.getString('itemPage::shippingLabel::labelSent')}</span>
                        <br/>
                        <span className="">{I18n.getJsx('itemPage::shippingLabel::itemNumber', {itemId: <span className="item-id">{this.state.item.id}</span>})}</span>
                    </div>
                    <div className="item-details">
                    {
                        isMobile() ?
                            this.props.ADO.working_hour ?
                                <button className="btn btn-gold call-us" ><a className="message-btn" href={`tel:${I18n.getString('common::phoneNumber')}`} >{callNowText}</a></button>
                                :
                                <button className="btn btn-gold call-us"  onClick={this._onHelp}>{callNowText}</button>
                        : <span>{I18n.getJsx('itemPage::shippingLabel::callUs::desktop', {phoneNumber: <span className="phone-number">{phoneNumber}</span>})}</span>
                    }
                    </div>
                    <div className="drop-off">
                        <h1 className="title">{I18n.getString('itemPage::shippingLabel::dropOff::title')}</h1>
                        <span className="text">{I18n.getString('itemPage::shippingLabel::dropOff::text')}</span>
                    </div>
                    <div className="fedex-branches">
                        <div className="fedex-pickup-locations">
                            {this.state.pickupLocations}
                        </div>
                    </div>
                </div>
                <div className="bottom-text">
                    {I18n.getJsx('itemPage::shippingLabel::bottomText::desktop', {fedexPhoneNumber: <span>{I18n.getString('common::fedexPhoneNumber')}</span>})}
                </div>
            </div>
        );
    }
}

ShippingLabel.propTypes = {
    item:                   PropTypes.object
};

ShippingLabel.defaultProps = {
    item:                   []
};

const mapStateToProps = ({ADO}) => {
    return {ADO}
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({updateSubmissionProgressState}, dispatch);
};

export default connect(mapStateToProps,mapDispatchToProps)(ShippingLabel);
